// har.utils.ts
// ────────────
export interface HarFile {
    log: {
      version: string;
      creator: object;
      entries: any[];
    };
  }
  
  /** Keep only the parts you need for OpenAPI generation */
  export function pruneHar(raw: HarFile): HarFile {
    const { version, creator } = raw.log;
  
    const prunedEntries = raw.log.entries.map((e) => {
      const {
        startedDateTime,
        time,
        timings = {},
        request,
        response,
      } = e;
  
      return {
        startedDateTime,
        time,
        timings,
        request: {
          method:        request.method,
          url:           request.url,
          httpVersion:   request.httpVersion,
          headers:       request.headers,
          cookies:       request.cookies,
          queryString:   request.queryString,
          postData:      request.postData,
        },
        response: {
          status:        response.status,
          statusText:    response.statusText,
          httpVersion:   response.httpVersion,
          headers:       response.headers,
          cookies:       response.cookies,
          content:       response.content,
          redirectURL:   response.redirectURL,
        },
      };
    });
  
    return { log: { version, creator, entries: prunedEntries } };
  }
  
  /** Turn a Blob (or File) into a data‑URL base‑64 string */
export const blobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

/** Turn a Blob (or File) into just the base64 content (without data URL prefix) for MongoDB storage */
export const blobToRawBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // Remove the "data:mime/type;base64," prefix and return just the base64 content
      const base64Content = result.split(',')[1];
      resolve(base64Content);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });